import { useCallback } from 'react';
import { usePreviewStore } from '../store/previewStore';

/**
 * Hook to easily open media preview modal from any component
 * Usage: const { openImagePreview, openVideoPreview, openAudioPreview } = useMediaPreview();
 */
export const useMediaPreview = () => {
  const openPreview = usePreviewStore((state) => state.openPreview);

  const openImagePreview = useCallback((url, title = 'Imagen') => {
    openPreview(url, 'image', title);
  }, [openPreview]);

  const openVideoPreview = useCallback((url, title = 'Video') => {
    openPreview(url, 'video', title);
  }, [openPreview]);

  const openAudioPreview = useCallback((url, title = 'Audio') => {
    openPreview(url, 'audio', title);
  }, [openPreview]);

  const openMediaPreview = useCallback((url, type, title) => {
    openPreview(url, type, title);
  }, [openPreview]);

  return {
    openImagePreview,
    openVideoPreview,
    openAudioPreview,
    openMediaPreview,
  };
};

export default useMediaPreview;
